export default "__VITE_ASSET__5hrz3Ig0__"